import {Button, Layout, Tabs, Typography} from 'antd';
import {React, useState} from 'react';
import appColors from '../../style/theme';
import EquationsT1 from './EquationsT1';
import EquationsT2 from './EquationsT2';

const {Paragraph, Text} = Typography;
const {Content} = Layout;

const EquationsTabs = () => {
  const [TAUno, setTAUno] = useState('white');
  const [GAUno, setGAUno] = useState(appColors['ColorX']);
  // others
  const [TUno, setTUno] = useState(appColors['ColorX']);
  const [GUno, setGUno] = useState(appColors['ColorG2']);

  const changeColor1 = (key) => {
    if (key === 'uno') {
      setTAUno('white');
      setGAUno(appColors['ColorX']);
      setTUno(appColors['ColorX']);
      setGUno(appColors['ColorG2']);
    } else if (key === 'dos') {
      setTAUno(appColors['ColorX']);
      setGAUno(appColors['ColorG2']);
      setTUno('white');
      setGUno(appColors['ColorX']);
    }
  };
  const items_ = [
    {label: <Button style={{height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TAUno, fontWeight: 'bold', borderColor: GAUno, background: GAUno}}>Structures at different<br/>multiplicities and configurations</Button>, key: 'uno', children: <EquationsT1/>},
    {label: <Button style={{height: '13vh', top: '2.3vh', fontSize: '2vh', borderWidth: '1.5vh', borderRadius: '1vh', color: TUno, fontWeight: 'bold', borderColor: GUno, background: GUno}}>Molecular properties calculations</Button>, key: 'dos', children: <EquationsT2/>},
  ];
  return (
    <Layout style={{margin: '5.2vh 5.2vh 5.2vh 5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className= 'Title3T' style={{color: appColors['ColorX']}}>Equations</Paragraph>
        <Text className='BaseText6'>In the same fashion as the previous subsection, you can also select the corresponding tab for each model to unravel the thought process we followed to come up with each model. Here you will be able to see how reducing the number of assumptions (by three) can make the model to be much more complicated.</Text>
      </Content>
      <Content style={{padding: '2vh', background: 'transparent', marginTop: '-6vh'}}>
        <Tabs
          tabBarGutter='4vh'
          defaultActiveKey="1"
          size='large'
          items={items_}
          onTabClick={changeColor1}
        />
      </Content>
    </Layout>
  );
};

export default EquationsTabs;
